import { useEffect, useRef } from 'react';

export function useInterval(callback, delay) {
  const savedCallback = useRef();
  const restart = useRef(0);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current(() => {
        restart.current += 1;
      });
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
    return () => {};
  }, [delay, restart.current]);
}

let globalIntervalCallBacks = [];
let globalIntervalId = null;

function globalIntervalCallback() {
  return globalIntervalCallBacks
    .filter(([c, shouldCall]) => c.current !== null && shouldCall.current)
    .map(([cb, , restart]) => {
      return cb.current === null
        ? null
        : cb.current(() => {
            restart.current += 1;
          });
    });
}
export function useGlobalInterval(callback, delay) {
  const savedCallback = useRef();
  const restart = useRef(0);
  const shouldCall = useRef(false);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    globalIntervalCallBacks.push([savedCallback, shouldCall, restart]);
    return () => {
      savedCallback.current = null;
      shouldCall.current = false;
      // clear callbacks cash when all instances unmount
      if (
        globalIntervalCallBacks.every(
          ([savedC, shouldC]) => savedC === null && shouldC.current === false
        ) &&
        globalIntervalId
      ) {
        clearInterval(globalIntervalId);
        globalIntervalId = null;
        globalIntervalCallBacks = [];
      }
    };
  }, []);

  useEffect(() => {
    if (delay !== null) {
      shouldCall.current = true;
      if (!globalIntervalId) {
        globalIntervalId = setInterval(globalIntervalCallback, delay);
      }
      return () => {
        shouldCall.current = false;
        if (
          globalIntervalCallBacks.every(([, sc]) => !sc.current) &&
          globalIntervalId
        ) {
          clearInterval(globalIntervalId);
          globalIntervalId = null;
        }
      };
    }
    shouldCall.current = false;

    return () => {};
  }, [delay, restart.current]);
}
